const topics = [
  {
    title: "Motion",
    slug: "motion",
    standardNumber: "1.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that objects can move in different ways.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmotion2025video.mp4?alt=media&token=90933e74-b520-41d9-8d19-f01f4a9a2204",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: ["(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"(Verse)",
"Use a car as an example, and the car is parked at the curb.",
"Now, you move the car up 10 feet, then a motion has occurred.",
"Now, if you take the same parked car and put it on the highway,",
"Then start coasting.",
"Its position is constantly changing.",
"Then, it's in motion, then it's in motion.",

"(Chorus)",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",
"If an object changes its position,",
"Then a motion has occurred.",
"If it continuously changes its position,",
"Then it's in motion, then it's in motion.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Instruments",
    slug: "instruments",
    standardNumber: "1.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that objects can move in different ways.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Finstruments2025video.mp4?alt=media&token=093de551-f834-49ce-8d4c-d57e59444a8e",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Finstruments2025song.mp3?alt=media&token=f1dd67e9-5b49-4fbd-b112-7726a694c558",
    lyrics: ["(Verse)",
"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the guitar’s vibrating strings,",
"That makes me want to sing.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the violin’s vibrating strings,",
"That makes me want to sing.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the flute’s vibrating air,",
"That’s the sound I love to hear.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the trumpet’s vibrating air,",
"That’s the sound I love to hear.",

"What do we hear making that sound?",
"What do we hear making that sound?",
"It’s the drum’s vibrating head,",
"Making me shake my head.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Sound Vibration",
    slug: "soundvibration",
    standardNumber: "1.2",
    description: "Force, Motion, and Energy – The student will investigate and understand that objects can move in different ways.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsoundvibration2025video.mp4?alt=media&token=cb99546b-37d4-4f3f-a966-0ce7a9d81ce3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsoundvibration2025song.mp3?alt=media&token=db451312-dd9d-4c4c-babe-357802dc1d67",
    lyrics: ["(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"(verse)",
"When you grab your guitar and pluck on the string,",
"Listen to the sound, it makes you want to sing.",
"Vibration, vibration, vibration, vibration.",
"You can speak very soft or speak very loud.",
"Your vocal cords vibrate producing sound.",
"Vibration, vibration, vibration, vibration.",

"(chorus)",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",
"If you did not know where sound came from, well now you know.",
"It’s from the vibration, it’s from the vibration.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Matter",
    slug: "matter",
    standardNumber: "1.3",
    description: "Matter – The student will investigate and understand that objects are made from materials that can be described by their physical properties.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmatterrock2025video.mp4?alt=media&token=9dcb63a2-cfea-49ca-8cc7-0d30700ecab3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmatterrock2025song.mp3?alt=media&token=78f1e7a9-8c65-4b5a-8489-430d502eb06c",
    lyrics: ["(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"(Verse)",
"Solids, they keep their shape.",
"Solids, they keep their shape.",
"Particles are packed tightly in solids, vibrating.",
"Particles are packed tightly in solids, vibrating.",

"Liquids take the shape of its container.",
"Liquids take the shape of its container.",
"Particles are spread out a little, sliding past each other.",
"Particles are spread out a little, sliding past each other.",

"In gases, the shape will change with its container.",
"In gases, the volume will change with its container.",
"Particles are spread out and move very quickly.",
"Particles are spread out and move very quickly.",

"(Chorus)",
"Matter has mass and takes up space.",
"Matter has mass and takes up space.",
"Three states of matter,",
"Solid, liquid, and gas.",
"Three states of matter,",
"Solid, liquid, and gas.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Things Plants Need",
    slug: "thingsplantsneed",
    standardNumber: "1.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants have basic life needs and functional parts that allow them to survive.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthingsplantsneed2025video.mp4?alt=media&token=13010d5d-3513-42e1-88ef-e35908d024cd",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthingsplantsneed2025song.mp3?alt=media&token=58839d9c-7e4f-40c7-bd9b-66865d87379b",
    lyrics: ["(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Verse 1)",
"Plants need water to drink each day,",
"It helps their roots in every way.",
"They reach for light from the sun so bright,",
"It helps them grow both day and night!",

"(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Verse 2)",
"Air is around, it helps them breathe,",
"It’s one more thing that plants do need.",
"With space to stretch and shelter near,",
"They grow so strong, year after year!",

"(Bridge)",
"Roots in the ground, leaves to the sky,",
"Plants grow tall and reach up high.",
"They need these things, it’s easy to see,",
"Water, air, light, and space are key!",

"(Chorus)",
"What do plants need? Let’s find out!",
"Water, air, and light, no doubt.",
"Shelter and space to grow up tall,",
"Plants need these to give us all!",

"(Outro)",
"So care for the plants, give them their space,",
"Water and sunlight in the right place.",
"Watch them grow, it’s fun to see,",
"Plants are special for you and me!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Plant Parts",
    slug: "plantparts",
    standardNumber: "1.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants have basic life needs and functional parts that allow them to survive.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantparts2025song.mp3?alt=media&token=016c634a-e689-489a-95c4-8ad4d07dfe2a",
    lyrics: ["(chorus)",
"Plant parts: Roots, stems, leaves, flowers, fruits, seeds.",
"Plant parts: Roots, stems, leaves, flowers, fruits, seeds.",

"(verse)",
"Plant parts: The roots take in the water and nutrients, ok.",
"The roots hold the plant down, so it does not blow away.",
"Plant parts: The Stem takes the water and nutrients up to the leaves.",
"The leaves make food, photosynthesis, yes they're green.",
"The flowers go through fertilization they make the seeds.",
"The fruit is the part that swells up and it holds the seeds.",
"The seed is a tiny plant called the embryo,",
"and it's waiting to germinate so that it can grow.",

"(chorus)",
"Plant parts: Roots, stems, leaves, flowers, fruits, seeds.",
"Plant parts: Roots, stems, leaves, flowers, fruits, seeds.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "What do Plants Need",
    slug: "whatdoplantsneed",
    standardNumber: "1.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants have basic life needs and functional parts that allow them to survive.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwhatdoplantsneed2025video.mp4?alt=media&token=2172b66c-8868-45bf-8a14-dd8f6be2f4ec",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatdoplantsneed2025song.mp3?alt=media&token=95132d97-2377-471a-9d92-9562b9dec2e7",
    lyrics: ["(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 1)",
"Animals need food and water.",
"Animals need food and water.",
"Animals need air and shelter.",
"Animals need air and shelter.",
"Some animals get their oxygen from the air.",
"That makes them terrestrial.",
"Some animals get their oxygen from the water.",
"That makes them aquatic.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"(Verse 2)",
"Plants need air, light, water, and nutrients from the soil.",
"Plants need air, light, water, and nutrients from the soil.",
"Plants provide food for people.",
"Plants provide food for animals.",
"Plants can be aquatic.",
"Plants can be terrestrial.",

"(Chorus)",
"Plants and animals change as they grow.",
"There are a few things we know",
"That they need for survival.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Plants and Animals Need Their Space",
    slug: "plantsandanimalsneedtheirspace",
    standardNumber: "1.4",
    description: "Living Systems and Processes – The student will investigate and understand that plants have basic life needs and functional parts that allow them to survive.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fplantsandanimalsneedtheirspace2025video.mp4?alt=media&token=db3fabd6-e651-4243-b8b5-fada18047b02",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fplantsandanimalsneedtheirspace2025song.mp3?alt=media&token=006814cd-57d6-4312-b230-a84afa79a47f",
    lyrics: ["(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 1)",
"Animals need water, food, and air,",
"Shelter from rocks or trees they share.",
"Plants need sunlight, space to grow,",
"And bees to help their seeds to sow!",

"(Chorus)",
"Plants and animals need their space,",
"Water, food, and a safe, good place.",
"Hot or cold, it must feel right,",
"So, they can grow and live their life!",

"(Verse 2)",
"A small change can mean a lot,",
"Too little water, or too hot.",
"The parts of nature work as one,",
"Helping life get what’s to be done!",

"(Outro)",
"Living and nonliving work together,",
"For plants and animals, now and forever.",
"An ecosystem is a home, it’s true,",
"Taking care of it is up to me and you!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Animal Needs",
    slug: "animalneeds",
    standardNumber: "1.5",
    description: "Living Systems and Processes – The student will investigate and understand that animals, including humans, have basic life needs that allow them to survive.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fanimallifecycle2025video.mp4?alt=media&token=a5f4b0b0-5ca0-436f-8d09-0b25bc2cc186",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fanimalneeds2025song.mp3?alt=media&token=53c6f12a-b401-47a5-b189-e4bcc774dc86",
    lyrics: ["(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 1)",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",
"Basic needs of animals, no need to wonder,",
"For animals to survive, they need food, shelter, and water.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"(Verse 2)",
"Some animals need sunlight, like plants on the ground.",
"Others need oxygen, to keep them safe and sound.",
"Every living creature, big or small, it’s true,",
"Depends on their environment, just like me and you.",

"(Chorus)",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",
"Basic needs of animals.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Habitats",
    slug: "habitats",
    standardNumber: "1.5",
    description: "Living Systems and Processes – The student will investigate and understand that animals, including humans, have basic life needs that allow them to survive.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhabitats2025video.mp4?alt=media&token=9d996902-5aa1-4927-bb6d-4ac291b420b2",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fhabitats2025song.mp3?alt=media&token=ac676b90-d3da-45be-8dcb-f0ad121b1ba0",
    lyrics: ["(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"(Verse)",
"In a habitat, you will find,",
"A group of organisms of the same kind,",
"Living together at the same time,",
"Living together.",
"Now that habitat supplies food,",
"Water, temperature just right,",
"Minerals—that’s right,",
"What organisms need to survive.",
"Ants have their own habitat (ant farms).",
"Bees have their own habitat (beehives).",
"Fish have their own habitats (water).",
"Toucans have a habitat (the rainforest).",

"(Chorus)",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",
"Habitats are places with populations.",
"Habitats are where plants or animals live.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "From the Sun",
    slug: "fromthesun",
    standardNumber: "1.6",
    description: "Earth and Space Systems – The student will investigate and understand that there is a relationship between the sun and Earth.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffromthesun2025song.mp3?alt=media&token=f88e1f0a-7fcb-49c8-b4c4-761369219c83",
    lyrics: ["(chorus)",
"The energy from the Sun keeps the water moving,",
"The energy from the Sun keeps the water grooving!",
"The energy from the Sun makes the cycle go,",
"The energy from the Sun makes the water flow!",

"(verse)",
"When the Sun heats the water, it turns into gas,",
"It rises in the air—evaporation, so fast!",
"When the vapor cools down, it turns back to the rain,",
"Falling to the Earth to start the cycle again.",

"(verse)",
"The Sun is the power that makes the water rise,",
"It forms clouds in the air, way up in the skies.",
"Then the water comes down as rain, hail, or snow,",
"Back to rivers and oceans, where the cycle flows.",

"(chorus)",
"The energy from the Sun keeps the water moving,",
"The energy from the Sun keeps the water grooving!",
"The energy from the Sun makes the cycle go,",
"The energy from the Sun makes the water flow!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "The Sun Brings Light",
    slug: "thesunbringslight",
    standardNumber: "1.6",
    description: "Earth and Space Systems – The student will investigate and understand that there is a relationship between the sun and Earth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthesunbringslight2025video.mp4?alt=media&token=9c5bcfa1-80ab-4aef-9fb0-9283b388ea70",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthesunbringslight2025song.mp3?alt=media&token=03d2d5c9-1da4-4232-9e9e-63e9cbdf3b69",
    lyrics: ["(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"(verse)",
"Light travels far from the sun to here,",
"It heats the Earth, the air so clear.",
"The land and water soak it in,",
"Patterns of warmth help life begin!",
"Reflecting light bounces back to space,",
"But the heat we keep is nature’s grace.",
"Plants grow tall, and oceans glow,",
"The sun’s bright energy makes it so!",

"(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",
"The sun brings light, the sun brings light,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"(verse)",
"Absorb the light, feel the heat,",
"The sun makes life a perfect feat.",
"Patterns of warmth, day by day,",
"The sun keeps life going in every way!",
"The sun is a star, a shining light,",
"It keeps us warm through day and night.",
"Reflect, absorb, the patterns we see,",
"The sun is the key to life’s harmony!",

"(chorus)",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",
"The sun brings light, the sun brings heat,",
"It warms the Earth beneath our feet.",
"Some light reflects, some light’s absorbed,",
"It powers the Earth, a life-giving force!",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Night & Day",
    slug: "night&day",
    standardNumber: "1.6",
    description: "Earth and Space Systems – The student will investigate and understand that there is a relationship between the sun and Earth.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnightandday2025video.mp4?alt=media&token=0df32858-e1bd-4e92-9c18-dc595d6b52a9",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdayandnight2025song.mp3?alt=media&token=2d2b7b35-895a-4226-8d35-bb5a2056564d",
    lyrics: ["(Intro)",
"Day and night, day and night, day and night, day and night.",
"Night and day, night and day, night and day, night and day.",

"(Chorus)",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",

"(Verse)",
"Because the Earth spins around,",
"And makes a full turn in 24 hours,",
"The sun only lights up half of the Earth at a time.",
"The side with the light is daytime.",
"The other side is dark—that’s nighttime.",
"As the Earth spins, daytime shifts to the other side.",
"As the Earth spins, nighttime shifts to the other side.",

"(Chorus)",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",
"In the daytime, you see the light and it’s dark at night,",
"Yeah, it’s dark at night,",
"Yeah, yeah, it’s dark at night.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Weather Patterns",
    slug: "weatherpatterns",
    standardNumber: "1.7",
    description: "Earth and Space Systems – The student will investigate and understand that there are weather and seasonal changes.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fweatherpatterns2025song.mp3?alt=media&token=34f3bcb1-2e6c-41af-af4b-4098fdbe04df",
    lyrics: ["(Verse 1)",
"Weather patterns happen every day,",
"From sunny skies to clouds so gray.",
"Temperature changes, hot or cold,",
"A seasonal story nature has told.",
"The sun’s rays warm the Earth, it’s true,",
"But sometimes we need the coolness too.",

"(Chorus)",
"Weather patterns, they come and they go,",
"From rain to snow, and wind that blows.",
"Let’s learn about them, let’s understand,",
"How they impact our lives, throughout the land.",

"(Verse 2)",
"Rain and snow both fall from the sky,",
"Thunder can rumble, and lightning flashes by.",
"The wind can blow strong, or just a breeze,",
"It shapes our weather and moves the seas.",
"From sunny days to stormy nights,",
"Weather affects our world in so many lights.",

"(Chorus)",
"Weather patterns, they come and they go,",
"From rain to snow, and wind that blows.",
"Let’s learn about them, let’s understand,",
"How they impact our lives, throughout the land.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Precipitation",
    slug: "precipitation",
    standardNumber: "1.7",
    description: "Earth and Space Systems – The student will investigate and understand that there are weather and seasonal changes.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fprecipitation2025video.mp4?alt=media&token=9be4503a-6378-41d1-be11-38eb8195d5c3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fprecipitation2025song.mp3?alt=media&token=7cc71098-743b-4545-9391-9b67a7d43062",
    lyrics: ["(Chorus)",
"Precipitation is rain, sleet, snow, and hail.",
"Precipitation is rain, sleet, snow, and hail.",
"It’s raining, it’s snowing.",
"It’s raining, it’s snowing.",
"It’s sleeting, it’s hailing.",
"It’s sleeting, it’s hailing.",

"(Verse)",
"Rain is water droplets falling from the sky.",
"Snow is white crystal flakes made of ice.",
"Sleet, small ice pellets that fall from the sky.",
"Hail, large ice pellets that fall from the sky.",

"(Chorus)",
"Precipitation is rain, sleet, snow, and hail.",
"Precipitation is rain, sleet, snow, and hail.",
"It’s raining, it’s snowing.",
"It’s raining, it’s snowing.",
"It’s sleeting, it’s hailing.",
"It’s sleeting, it’s hailing.",

"© Smart Board Learning, LLC. All rights reserved.",
],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Seasons",
    slug: "seasons",
    standardNumber: "1.7",
    description: "Earth and Space Systems – The student will investigate and understand that there are weather and seasonal changes.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fseasons2025video.mp4?alt=media&token=dd682414-ff8a-4acb-8877-5a488cd7a912",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fseasons2025song.mp3?alt=media&token=04a34ce0-7b3c-4e70-8564-cc5ac75c2bfc",
    lyrics: ["(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(verse)",
"We spring ahead in the Spring, then comes the Summer.",
"Watch the leaves change color, we fall back in Autumn.",
"Then comes the Winter, which is the coldest season.",
"The Earth spins on an axis that is tilted, is the reason why this happens.",

"(chorus)",
"There is something we have to get clear now,",
"there are four seasons in every year now.",
"Do you know the reasons for the seasons? Check this,",
"seasons come because of the tilt of the Earth's axis.",

"(bridge)",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",
"Summer, Winter, Spring, Fall.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Natural Resources",
    slug: "naturalresources",
    standardNumber: "1.8",
    description: "Earth Resources – The student will investigate and understand that natural resources can be used responsibly.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Pollution",
    slug: "pollution",
    standardNumber: "1.8",
    description: "Earth Resources – The student will investigate and understand that natural resources can be used responsibly.",
    video: "",
    music: "",
    lyrics: ["(chorus)",
"Pollution is when there’s contaminants in the environment,", 
"and it’s out of control, and it’s out of control,", 
"and it’s out of control, and it’s out of control.", 
"Pollution is when there’s contaminants in the environment,", 
"and it’s out of control, and it’s out of control,", 
"and it’s out of control, and it’s out of control.",

"(verse)",
"Air pollution, the major cause comes from car exhaust,", 
"and from combustion of coal and from acid rain and from tobacco.", 
"Water pollution can come from industrial.", 
"They waste acids, poisons, oils in some cases.", 
"Even in agriculture the pesticides and fertilizers", 
"pollute the waters and so do we, pollute the waters don’t you agree?", 
"Soil pollution comes from the weed killers, right?", 
"Pollution also comes from the insect killers called pesticides.", 
"Pollution comes from what we throw on the ground and take for granted.", 
"Yes, it’s us, polluting and hurting the planet.",

"(chorus)",
"Pollution is when there’s contaminants in the environment,", 
"and it’s out of control, and it’s out of control,", 
"and it’s out of control, and it’s out of control.", 
"Pollution is when there’s contaminants in the environment,", 
"and it’s out of control, and it’s out of control,", 
"and it’s out of control, and it’s out of control.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },
  {
    title: "Reduce Reuse and Recycle",
    slug: "reducereuseandrecycle",
    standardNumber: "1.8",
    description: "Earth Resources – The student will investigate and understand that natural resources can be used responsibly.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Freducereuseandrecycle2025video.mp4?alt=media&token=e70c95fb-a41d-41b7-b8c3-ef00cb03b098",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Freducereuserecycle2025song.mp3?alt=media&token=55526bc5-628f-4a12-94b4-b0b6ea6dda21",
    lyrics: ["(Chorus)",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling can eliminate waste.",

"(Verse)",
"You can reduce by refusing store bags.",
"Carry small items out in your hands.",
"You can reuse cups that’s washable,",
"Instead of foam cups that’s disposable.",
"You can recycle papers and plastics, papers, and plastics,",
"Yup, yup, yup, papers and plastics.",

"(Chorus)",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling protects your environment.",
"Reducing, reusing, and recycling can eliminate waste.",

"© Smart Board Learning, LLC. All rights reserved.",],
    gameType: "multipleChoice",
    titleImage: "",
  },

];
export default topics;
